var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.ordered ? 'kayako' : '',attrs:{"title":_vm.ordered ? 'Check order status' : ''},on:{"click":function($event){_vm.ordered ? _vm.showOrderDetails() : ''}}},[_vm._v(_vm._s(_vm.orderInfo.orderID))])])}
var staticRenderFns = []

export { render, staticRenderFns }